export class LoginException extends Error {
  public static ERROR_NAME = 'LoginException';

  constructor(public message: string, public url: string, public code: string) {
    super('Login exception');
    this.name = LoginException.ERROR_NAME;
  }
}
